import {useMsal} from "@azure/msal-react";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo, faFolderOpen} from "@fortawesome/free-solid-svg-icons";

function Home(){

    const auth=useMsal();
    const user=auth.accounts[0].username

    const loggUt = () => {
        const logoutRequest = {
            account: auth.instance.getAllAccounts()[0],
            postLogoutRedirectUri: "https://legeforeningen.no"
        };
        auth.instance.logoutRedirect(logoutRequest);
    };

    return (
        <div className="home-page">
            <div className="home-card">
                <div className="home-card-header">
                    <h1>Refusjon for kvalitetsforbedringsarbeid</h1>
                    <p>Søknadsskjema for fastleger</p>
                </div>
                <div className="home-card-body">
                    <div className="home-notice" role="status">
                        <h2 className="home-notice-title">
                            <FontAwesomeIcon icon={faCircleInfo} aria-hidden="true" />
                            Søknadsordningen er avsluttet
                        </h2>
                        <p>
                            De avsatte midlene er nå fordelt, og det er derfor dessverre ikke lenger mulig å søke om refusjon fra denne ordningen.
                        </p>
                    </div>

                    <div className="home-about">
                        <h2>Om ordningen</h2>
                        <p>
                            Ordningen dekket kostnader ved fravær fra praksis i forbindelse med kurs i kvalitetsforbedringsarbeid og/eller pasientsikkerhet for fastleger.
                        </p>
                    </div>

                    <Link to="/soknader" className="btn btn-primary home-cta">
                        <FontAwesomeIcon icon={faFolderOpen} className="me-2" aria-hidden="true" />
                        Se mine søknader
                    </Link>

                    <p className="home-user">
                        Du er logget inn som <strong>{user}</strong>.
                        {" "}Dersom dette ikke er deg,{" "}
                        <button type="button" className="home-user-link" onClick={loggUt}>
                            logg ut og logg inn på nytt
                        </button>.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Home;
